<mat-horizontal-stepper class="wizard-background" linear="true" #stepper>
    <mat-step>
        <ng-template matStepLabel>Paciente</ng-template>
        <app-integrated-admission-patient #patient *ngIf="!loading"></app-integrated-admission-patient>
    </mat-step>

    <mat-step>
        <ng-template matStepLabel>Turno</ng-template>
        <app-integrated-admission-appointment-list *ngIf="!loading"></app-integrated-admission-appointment-list>
    </mat-step>
</mat-horizontal-stepper>

<button type="button" (click)="cancel()" style="z-index: 1000; position: fixed; bottom: 15px; right: 15px" mat-fab>
  <mat-icon>close</mat-icon>
</button>
